import styled from 'styled-components';

// export const Header = styled.div`
//   position: sticky;
//   top: 0;
//   background: var(--color-point-gradient);
//   z-index: 1;

//   > :first-child {
//     div {
//       z-index: 1;
//       border-bottom: none;
//     }
//     article {
//       display: none;
//     }
//   }
// `;

export const BackIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 4L10 6L4 12L10 18L8 20L0 12L8 4Z"
      fill="#948F9E"
    />
  </svg>
);

export const SettingIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M9.2502 22L8.8502 18.8C8.63353 18.7167 8.42936 18.6167 8.2377 18.5C8.04603 18.3833 7.85853 18.2583 7.6752 18.125L4.7002 19.375L1.9502 14.625L4.5252 12.675C4.50853 12.5583 4.5002 12.4458 4.5002 12.3375V11.6625C4.5002 11.5542 4.50853 11.4417 4.5252 11.325L1.9502 9.375L4.7002 4.625L7.6752 5.875C7.85853 5.74167 8.0502 5.61667 8.2502 5.5C8.4502 5.38333 8.6502 5.28333 8.8502 5.2L9.2502 2H14.7502L15.1502 5.2C15.3669 5.28333 15.571 5.38333 15.7627 5.5C15.9544 5.61667 16.1419 5.74167 16.3252 5.875L19.3002 4.625L22.0502 9.375L19.4752 11.325C19.4919 11.4417 19.5002 11.5542 19.5002 11.6625V12.3375C19.5002 12.4458 19.4835 12.5583 19.4502 12.675L22.0252 14.625L19.2752 19.375L16.3252 18.125C16.1419 18.2583 15.9502 18.3833 15.7502 18.5C15.5502 18.6167 15.3502 18.7167 15.1502 18.8L14.7502 22H9.2502ZM12.0502 15.5C13.0169 15.5 13.8419 15.1583 14.5252 14.475C15.2085 13.7917 15.5502 12.9667 15.5502 12C15.5502 11.0333 15.2085 10.2083 14.5252 9.525C13.8419 8.84167 13.0169 8.5 12.0502 8.5C11.0669 8.5 10.2377 8.84167 9.5627 9.525C8.8877 10.2083 8.5502 11.0333 8.5502 12C8.5502 12.9667 8.8877 13.7917 9.5627 14.475C10.2377 15.1583 11.0669 15.5 12.0502 15.5Z"
      fill="#948F9E"
    />
  </svg>
);

export const Header = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
  background: ${prev => prev.theme.palette.bg900};
  > :first-child {
    div {
      z-index: 1;
      border-bottom: none;
    }
    article {
      display: none;
    }
  }
`;

export const ChartHeader = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid var(--color-white);
`;

export const ListContainer = styled.div`
  background-color: var(--color-background);
  padding: 1rem 0 3rem;
`;

export const Header2 = styled.div`
  background: var(--BG-bg-900, #18161c);
  display: flex;
  width: 100%;
  height: 56px;
  padding: 16px 20px;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
`;

export const HeaderMainText = styled.div`
  color: var(--Gray-Scale-400, #bcb8c3);

  /* NEW/title_03_semibold */
  font-family: 'Pretendard Variable';
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 120% */
  letter-spacing: 0.38px;
`;

export const IconContainer = styled.div`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  cursor: pointer; /* 클릭 가능하도록 커서 변경 */
  &:hover {
    opacity: 0.8; /* 호버 시 약간의 투명도 변경 */
  }
`;

export const Button = styled.div`
  display: flex;
  padding: 20px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;

  border-radius: 8px;
  border: 1px solid var(--bg-500, #373245);
  background: var(--bg-600, #2e2a3a);

  .title {
    color: var(--Gray-Scale-300, #d7d3de);
    text-align: center;

    /* NEW/body_01_medium */
    font-family: 'Pretendard Variable';
    font-size: 17px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px; /* 129.412% */
    letter-spacing: -0.41px;
  }

  .desc {
    color: var(--Gray-Scale-500, #948f9e);
    text-align: center;

    /* NEW/body_02_regular */
    font-family: 'Pretendard Variable';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px; /* 131.25% */
    letter-spacing: -0.32px;
  }
`;

export const SettingContainer = styled.div`
  display: flex;
  padding: 10px;
  margin-top: 20px;
  flex-direction: column;
  align-items: center;
  align-self: center;
  gap: 12px;
  align-self: stretch;
`;

export const SettingTextContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  align-self: stretch;
`;

export const SettingButtonContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

export const SettingButton = styled.div`
  border-radius: 8px;
  border: 1px solid var(--Brand-400, #7750e9);
  background: var(--BG-bg-600, #2e2a3a);
  display: flex;
  padding: 12px 40px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
`;

export const SettingText = styled.div`
  color: var(--Gray-Scale-400, #bcb8c3);

  /* NEW/body_02_medium */
  font-family: 'Pretendard Variable';
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px; /* 131.25% */
  letter-spacing: -0.32px;
`;
